/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createPrivateAccountHook } from '../../core/factories/createPrivateAccountHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMeRow } from '../openapi-types.gen.js';
import { type useGetMeArgs, useGetMeSpec } from '../specs/me.spec.gen.js';

export type { GetMeRow } from '../openapi-types.gen.js';
export type { useGetMeArgs } from '../specs/me.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): kind.
 */
export const useGetMe = createPrivateAccountHook(useGetMeSpec);


/**
 * Hover/intent prefetch companion for `useGetMe`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMe();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMe = createPrefetchHook(useGetMeSpec);
